import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@portals/core';
import { Collectible, CollectibleType } from '@portals/api';
import { environment } from '@portals/environments';

@Component({
	selector: 'portals-report-details',
	templateUrl: './report-details.component.html',
	styleUrls: ['./report-details.component.scss'],
})
export class ReportDetailsComponent extends BaseComponent implements AfterViewInit {
	type = CollectibleType;
	@Input() collectible!: Collectible;
	@Input() flagged = false;
	@Input() transcription = false;
	@Output() flagChange = new EventEmitter<any>();
	app = environment.app;

	constructor() {
		super();
	}

	ngAfterViewInit(): void {
		// console.log(this.collectible)
	}
}
